import React from 'react'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './SidebarFrame.css'
import { motion } from "framer-motion"

const SidebarFrame = ({ title, children, hide }) => {
  return (
    <motion.div 
      className="sidebar__frame"
      animate={{
        x: 0,
        opacity: 1
      }}
      initial={{
        x: -30,
        opacity: 0
      }}
      transition={{duration: 0.4}}
      exit={{
        x: -500,
        // opacity: 0
      }}
    >
      <div className="sidebar__frame__header">
        <div className="sidebar__frame__header__container">
          <ArrowBackIcon onClick={hide} />
          <h3>{title}</h3>
        </div>
      </div>
      <div className="content">
        {children}
      </div>
    </motion.div>
  )
}

export default SidebarFrame